module.exports = __webpack_public_path__ + "static/img/Isaac-Liu.3271be0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Isaac-Liu.jpg
// module id = sYpS
// module chunks = 0